export interface IUnderlyingAmount {
  UnderlyingPayAmount?: number// 985
  UnderlyingCollectAmount?: number// 986
  UnderlyingSettlementDate?: Date// 987
  UnderlyingSettlementStatus?: string// 988
}
